import { ReactElement, useEffect } from 'react'
import { Table } from 'react-bootstrap'
import {
  PageWrapper,
  SectionTitle,
  TableWrapper,
  TableHeader,
  Loader,
  FlexWrapper,
  EditableDropdown
} from '../../../../components'
import strings from '../../../../locale/en'
import { FormBackWrapper, TableRow } from '../../User/subcomponents'
import { ActionList, tableHeader } from './consts'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import {
  getLeaveDetails,
  getLeaveStatusDetails,
  getLeaveStatus,
  resetLeaveDetails,
  approveLeave,
  rejectLeave
} from '../../../../redux/manageLeave/action'
import { Leave } from '../../../../redux/manageLeave/type'
import { formatDate } from '../../../../helpers'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../../../const/routes'
import LeaveAction from '../LeaveAction'

const LeaveDetails = (): ReactElement => {
  const { leaves, isLoading } = useSelector(
    (state: RootState) => ({
      leaves: state.leave.leaveDetails,
      isLoading: state.leave.isLoading
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    menu: {
      leave: { details, selectStatus }
    }
  } = strings

  useEffect(() => {
    dispatch(getLeaveDetails())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <SectionTitle title={details} hasBorder />
      <FlexWrapper>
        <EditableDropdown
          dropdownList={ActionList}
          placeholder={selectStatus}
          width="30%"
          handleSelect={({ id }) => {
            dispatch(resetLeaveDetails())
            if (id === 'Show All') dispatch(getLeaveDetails())
            else dispatch(getLeaveStatusDetails(id))
          }}
        />
      </FlexWrapper>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <FormBackWrapper>
            <TableWrapper>
              <Table size="sm" responsive="sm">
                <TableHeader>
                  <TableRow>
                    {tableHeader?.map((header, index) => (
                      <th key={`leave-details-header-${index}`}>{header}</th>
                    ))}
                  </TableRow>
                </TableHeader>
                <tbody>
                  {leaves?.map(
                    (
                      {
                        id,
                        leaveType,
                        fromDate,
                        toDate,
                        dayStatus,
                        leaveName,
                        action
                      }: Leave,
                      index
                    ) => (
                      <TableRow key={`leave-${index}`}>
                        <td>{leaveType}</td>
                        <td>{leaveName}</td>
                        <td>{formatDate(fromDate)}</td>
                        <td>{formatDate(toDate)}</td>
                        <td>{action || '-'}</td>
                        <td>{dayStatus}</td>
                        <td>
                          <LeaveAction
                            handleLeaveDetail={() => {
                              dispatch(getLeaveStatus(id))
                              history.push(ROUTES.VIEW_LEAVE_STATUS)
                            }}
                            {...(!action
                              ? {
                                handleLeaveApprove: () => {
                                  dispatch(approveLeave(id))
                                },
                                handleLeaveReject: () => {
                                  dispatch(rejectLeave(id))
                                }
                              }
                              : {})}
                          />
                        </td>
                      </TableRow>
                    )
                  )}
                </tbody>
              </Table>
            </TableWrapper>
          </FormBackWrapper>
        </div>
      )}
    </PageWrapper>
  )
}

export default LeaveDetails
